import React, { useState, useEffect } from "react";
import { Col, Row } from "react-bootstrap";
import { useSolarCalc } from "../../../../util/calculations";
import { applyDecrement, calculatePvsystProd } from "../../../../util/targetCalc";

const TargetAsbuiltSection = (props) => {
	const calc = useSolarCalc();
	const register = props.register;
	const isEditMode = props.isEditMode;
	const setValue = props.setValue;
	const watch = props.watch;
	const data = props.data;

	const [capacity, setCapacity] = useState(0);
	const [totalEGrid, setTotalEGrid] = useState(0);
	const [totalCorr, setTotalCorr] = useState(0);

	const netYield = watch("net_yield", data.net_yield);
	const netYieldUnused = watch("net_yield_un", data.net_yield_un);
	const BPYield = watch("BP_yield", data.BP_yield);
	const pvsystProd = watch("pvsyst_prod", data.pvsyst_prod);
	const [errors, setErrors] = useState({});

	/**
	 * Handle input change
	 * @param {event} evt
	 * @returns
	 */
	const handleChange = (evt, inputName) => {
		const value = evt.target.value;
		setValue(inputName, value);
	};

	useEffect(() => {
		if (props.capacity != capacity) setCapacity(props.capacity);
	}, [props.capacity]);

	useEffect(() => {
		if (props.totalEGrid != totalEGrid) setTotalEGrid(props.totalEGrid);
	}, [props.totalEGrid]);

	useEffect(() => {
		if (props.totalCorr != totalCorr)
			setTotalCorr(calc.parseFormatNumber(props.totalCorr / 100, 3));
	}, [props.totalCorr]);

	useEffect(() => {
		if (capacity > 0) {
			const pvsystProdCalc = calculatePvsystProd(totalEGrid, capacity);
			setValue("pvsyst_prod", pvsystProdCalc);
		} else setValue("pvsyst_prod", 0);
	}, [capacity, totalEGrid]);

	useEffect(() => {
		const netYield = applyDecrement(pvsystProd, totalCorr, 2);
		const avgUnused = calc.parseFormatNumber(props.avgUnused / 100, 3);
		const netYieldUnused = applyDecrement(netYield, avgUnused, 2);

		setValue("net_yield", netYield);
		setValue("net_yield_un", netYieldUnused);
	}, [pvsystProd, totalCorr, props.avgUnused]);

	useEffect(() => {
		if (props.data != null) {
			const data = props.data;

			setValue("net_yield", data.net_yield);
			setValue("net_yield_un", data.net_yield_un);
			setValue("BP_yield", data.BP_yield);
			setValue("pvsyst_prod", data.pvsyst_prod);
		}
	}, [props.data]);

	useEffect(() => {
		setErrors(props.errors);
	}, [props.errors]);

	return (
		<>
			<hr />
			<h5>Productible (kWh/kWp)</h5>
			<hr />
			<Row>
				<Col md="12">
					{/* Asbuilt PVsyst Yield column */}
					<Col md="4">
						<Col md="6">
							<label htmlFor="pvsyst_prod">Asbuilt PVsyst Yield</label>
							{errors.pvsyst_prod && errors.pvsyst_prod.type == "required" && (
								<span className="required">*required</span>
							)}
						</Col>
						<Col md="6">
							<b>
								<input
									type="number"
									step="0.01"
									ref={register}
									name="pvsyst_prod"
									defaultValue={pvsystProd}
									readOnly={true}
									onChange={(evt) => handleChange(evt, "pvsyst_prod")}
								></input>
							</b>
						</Col>
					</Col>

					{/* Net yield column */}
					<Col md="4">
						{/* Net Yield including Unused */}
						<Row>
							<Col md="6">
								<label htmlFor="net_yield_un">Net Yield including Unused</label>
								{errors.net_yield_un &&
									errors.net_yield_un.type == "required" && (
										<span className="required">*required</span>
									)}
							</Col>
							<Col md="6">
								<b>
									<input
										type="number"
										step="0.01"
										ref={register}
										name="net_yield"
										defaultValue={netYield}
										readOnly={true}
										onChange={(evt) => handleChange(evt, "net_yield")}
									></input>
								</b>
							</Col>
						</Row>
						{/* Net Yield excluding Unused */}
						<Row>
							<Col md="6">
								<label htmlFor="net_yield_un">Net Yield excluding Unused</label>
								{errors.net_yield_un &&
									errors.net_yield_un.type == "required" && (
										<span className="required">*required</span>
									)}
							</Col>
							<Col md="6">
								<b>
									<input
										type="number"
										step="0.01"
										ref={register}
										name="net_yield_un"
										defaultValue={netYieldUnused}
										readOnly={true}
										onChange={(evt) => handleChange(evt, "net_yield_un")}
									></input>
								</b>
							</Col>
						</Row>
					</Col>

					{/* Net BP Yield column */}
					<Col md="4">
						<Col md="6">
							<label htmlFor="BP_yield">Net BP Yield</label>
							{errors.BP_yield && errors.BP_yield.type == "required" && (
								<span className="required">*required</span>
							)}
						</Col>
						<Col md="6">
							<input
								type="number"
								step="0.01"
								ref={register}
								name="BP_yield"
								defaultValue={BPYield}
								readOnly={!isEditMode}
								onChange={(evt) => handleChange(evt, "BP_yield")}
							></input>
						</Col>
					</Col>
				</Col>
			</Row>
		</>
	);
};

export default TargetAsbuiltSection;
